var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.my_bank_accounts_statements") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "m-0 pb-3 showSmallScreenOnly no-gutters" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _vm.isSmartphoneOS
            ? _c(
                "div",
                [
                  _c("f7-searchbar", {
                    staticClass: "search w-100 z-10",
                    attrs: {
                      id: "searchBankAccount",
                      "cancel-link": _vm.$t("common.cncl"),
                      "search-list": "#bank-list",
                      placeholder: _vm.$t("bank_accounts.srch_in_accnts"),
                    },
                    on: {
                      "searchbar:search": _vm.onSearch,
                      "searchbar:clear": _vm.onClear,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "listPage" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-center" },
                    [
                      !_vm.isSmartphoneOS
                        ? _c("f7-searchbar", {
                            staticClass: "search filterTitle",
                            attrs: {
                              id: "searchBankAccount",
                              "cancel-link": _vm.$t("common.cncl"),
                              "search-list": "#bank-list",
                              placeholder: _vm.$t(
                                "bank_accounts.srch_in_accnts"
                              ),
                            },
                            on: {
                              "searchbar:search": _vm.onSearch,
                              "searchbar:clear": _vm.onClear,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "form-group showLargeScreenOnly mb-27px no-gutters",
                },
                [
                  !_vm.isSmartphoneOS
                    ? _c("back-button", { attrs: { returnUrl: _vm.returnUrl } })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemList" },
                [
                  _c("div", { staticClass: "layoutSubtitle" }),
                  _vm._v(" "),
                  _c(
                    "f7-list",
                    { staticClass: "searchbar-not-found" },
                    [_c("f7-list-item", { attrs: { title: "Nothing found" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("cm-bank-accounts-list-statement", {
                    attrs: {
                      bankAccounts: _vm.bankAccounts,
                      filterBy: _vm.filterBy,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "toolbarPageBottomBlank" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }